export const REVIEW_OPEN = "REVIEW_OPEN";
export const REVIEW_CLOSED = "REVIEW_CLOSED";
